exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container[data-v-12521a5e]{width:100%}.empty-space[data-v-12521a5e]{width:8%}.modal-header[data-v-12521a5e]{background:#000;border:none;height:85px}.modal-header h3[data-v-12521a5e]{color:#fff!important;margin:0;font-family:artifaktElementBold!important}.modal-title-container[data-v-12521a5e]{width:80%}.close-btn[data-v-12521a5e]{outline:none;cursor:pointer;width:10%}.close-btn svg[data-v-12521a5e]{color:#fff}", ""]);

// exports
